export default {
  saveFileError: '保存文件bin文件或map文件失败',
  replaceResourcesError: '替换资源失败',
  uuid2UrlError: 'uuid2url为空',
  assetTypeError: '当前选中的图片类型不是 ASSET_ATLAS',
}
